import { AxiosPromise } from "axios";
import { request } from "utils/request";

export const projectApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/project",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/project",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/project/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/project/${id}`,
      method: "delete",
    }),
};
